(function () {
  'use strict';
  const node = document.getElementById('promotion-journey-context');
  if (!node) return;
  const context = JSON.parse(node.textContent);
  const key = 'domain-campaign-auth';
  const zh = context.locale.startsWith('zh');
  const read = () => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const clear = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const fresh = record => ['gniib', 'login'].includes(record?.source) && Number.isFinite(record.at) && Date.now() - record.at >= 0 && Date.now() - record.at < 86400000;
  const root = context.root === '/' ? '' : context.root.replace(/\/$/, '');
  const source = new URLSearchParams(location.search).get('domain_promotion') === 'gniib' || read()?.source === 'gniib' ? 'gniib' : 'login';
  const returnPath = root + '/account?domain_promotion=' + source;
  // Record intent on arrival, including customers already signed in to this store.
  // The source flag grants no eligibility; the authenticated proxy checks the email.
  const handoff = ['gniib', 'login'].includes(new URLSearchParams(location.search).get('domain_promotion'));
  if (handoff) {
    try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), source })); } catch (_) {}
  }
  if (!context.signedIn) {
    if (handoff && !/\/(?:account|customer_authentication)(?:\/|$)/.test(location.pathname)) {
      const register = new URLSearchParams(location.search).get('auth') === 'register';
      location.replace((register ? context.register : context.login) + '?domain_promotion=' + source);
      return;
    }
    const promotionLogin = () => handoff || fresh(read());
    // Every account submission can discover a domain or remembered code destination.
    function prepareForm(form) {
      if (!['customer_login', 'create_customer', 'activate_customer_password'].includes(form.querySelector('[name="form_type"]')?.value)) return;
      let input = form.querySelector('[name="return_to"]');
      // Explicit campaign and checkout destinations always win.
      const destination = input?.value || new URLSearchParams(location.search).get('return_to') || new URLSearchParams(location.search).get('return_url');
      if (destination && destination !== returnPath) { clear(); return; }
      if (!input) {
        input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.append(input);
      }
      input.value = returnPath;
    }
    document.querySelectorAll('form').forEach(prepareForm);
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || !/\/(account(?:\/login|\/register)?|customer_authentication\/login)\/?$/.test(url.pathname)) return;
      if (promotionLogin() && /\/(?:account|customer_authentication)(?:\/|$)/.test(location.pathname) && !url.searchParams.has('return_to') && !url.searchParams.has('return_url')) {
        url.searchParams.set('domain_promotion', source);
        link.href = url.href;
      } else if (url.searchParams.get('domain_promotion') !== 'gniib') clear();
    }, true);
    document.addEventListener('submit', event => prepareForm(event.target), true);
    return;
  }
  const auth = read();
  const afterAuth = handoff || fresh(auth);
  clear();
  // Consume the URL marker too: reload/back/account visits must not redirect again.
  if (handoff) {
    const clean = new URL(location.href);
    clean.searchParams.delete('domain_promotion'); clean.searchParams.delete('auth');
    window.history.replaceState(window.history.state, '', clean.pathname + clean.search + clean.hash);
  }
  // History and approvals share customer storage but have independent expiries.
  const store = window.PromotionStorage?.forCustomer(context.customerId);
  const campaignId = value => typeof value === 'string' && /^[a-zA-Z0-9_.-]+$/.test(value);
  async function rememberedCodeDestination(domainLookup) {
    if (!store) return null;
    const record = store.destination();
    const current = /\/pages\/promotion\/?$/.test(location.pathname)
      ? new URLSearchParams(location.search).get('campaign') : null;
    const id = campaignId(current) ? current : record?.campaign;
    if (!id) return null;
    const checkedGrant = store.campaigns()[id]?.grant;
    try {
      const response = await fetch('/apps/gift-promotions/destination?method=code&campaign=' + encodeURIComponent(id),
        { cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (!response.ok) {
        if (response.status === 404) {
          if (record?.campaign === id) store.forgetDestination(id);
          store.clearApproval(id, checkedGrant);
        }
        return null;
      }
      const data = await response.json();
      if (!data.available || data.navigationType !== 'code' || data.campaign !== id
          || data.path !== '/pages/promotion?campaign=' + encodeURIComponent(id)) return null;
      const domain = await domainLookup;
      const domainVisit = domain.state === 'eligible' && (domain.domainAccepted === true
        || (domain.domainAccepted === undefined && domain.campaign && domain.campaign.path === '/pages/promotion?campaign=' + encodeURIComponent(domain.campaign.id)));
      if (current === id && !domainVisit) {
        store.rememberDestination(id);
      }
      return { id, name: data.title, path: data.path };
    } catch (_) { return null; } // Keep history through temporary outages.
  }
  window.domainCampaignReady = (async () => {
    try {
      const domainLookup = fetch('/apps/gift-promotions/domain-campaign', { cache: 'no-store', signal: AbortSignal.timeout(8000) })
        .then(response => response.ok ? response.json() : {}).catch(() => ({}));
      const [result, codeCampaign] = await Promise.all([domainLookup, rememberedCodeDestination(domainLookup)]);
      const domainDestination = result.state === 'eligible' && result.campaign;
      const campaign = domainDestination || codeCampaign;
      if (!campaign) return;
      const path = campaign.path || '/pages/promotion?campaign=' + encodeURIComponent(campaign.id);
      // Accept only promotion pages and product paths from destination discovery.
      if (!/^\/products\/[a-zA-Z0-9_-]+$/.test(path) && !/^\/pages\/promotion\?campaign=[a-zA-Z0-9_%.-]+$/.test(path)) return;
      // The domain-only endpoint returned
      // promotion-page destinations before domainAccepted was added. Support that
      // response during app/theme rollout; role/code matches never reach this branch
      // on the server. Remembered code destinations separately enable the same
      // retail visibility rules; the existing Staff shortcut remains excluded.
      const legacyDomainMatch = domainDestination && result.domainAccepted === undefined
        && campaign.id && campaign.id !== 'staff'
        && campaign.path === '/pages/promotion?campaign=' + encodeURIComponent(campaign.id);
      document.documentElement.classList.toggle('domain-retail-hidden',
        result.domainAccepted === true || Boolean(legacyDomainMatch) || Boolean(!domainDestination && codeCampaign));
      const destination = root + path;
      document.querySelectorAll('[data-domain-campaign-link]').forEach(link => {
        link.href = destination;
        link.textContent = zh ? '專屬優惠' : 'Your exclusive offer';
        link.title = campaign.name || link.textContent;
        link.parentElement.hidden = false;
      });
      // Both destinations use the same one-time authentication return safeguards.
      if (afterAuth && !window.promotionReturnPending && !/\/(?:cart|checkouts?)(?:\/|$)/.test(location.pathname) && !/\/pages\/promotion\/?$/.test(location.pathname) && !/checkout/i.test(location.search)) {
        window.promotionReturnPending = true;
        try { sessionStorage.removeItem('corporate_login_redirect'); } catch (_) {}
        location.replace(destination);
      }
    } catch (_) { /* Preserve the normal storefront during a temporary outage. */ }
    finally {
      clearTimeout(window.domainRetailPendingTimeout);
      document.documentElement.classList.remove('domain-retail-pending');
    }
  })();
})();
